'use client'

import { useEffect } from 'react'

import { logErrorToSentry } from 'app/utils/logErrorToSentry'

import GlobalErrorContent from './components/GlobalErrorContent'

interface ErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function GlobalError({ error, reset }: ErrorProps) {
  useEffect(() => {
    const isServerError = /Internal Server Error/i.test(error.message)

    logErrorToSentry(error, isServerError ? 'http_500' : 'unexpected', {
      digest: error.digest,
      pathname: window.location.pathname,
      statusCode: isServerError ? 500 : undefined,
      platform: process.env.BRAND === 'pulsz' ? 'pulsz' : 'bingo',
    })
  }, [error])

  return (
    <html>
      <body className='ysi'>
        <GlobalErrorContent onReload={reset} />
      </body>
    </html>
  )
}
